import styled from 'styled-components';

const ListItemElement = styled.li({});

export { ListItemElement };
